import React, { createContext, useContext } from 'react';
import useWebCheckIns from '../hooks/useWebCheckIns';

// Create context
const WebCheckInContext = createContext(null);

/**
 * Provider component for web check-in data
 * @param {Object} props - Component props
 * @param {boolean} props.isB2bUser - Whether this is for B2B users
 * @returns {JSX.Element} Provider component
 */
export const WebCheckInProvider = ({ children, isB2bUser = false }) => {
  console.log('WebCheckInProvider rendering with isB2bUser:', isB2bUser);
  const checkInData = useWebCheckIns(isB2bUser);
  
  return (
    <WebCheckInContext.Provider value={checkInData}>
      {children}
    </WebCheckInContext.Provider>
  );
};

/**
 * Custom hook to use the web check-in context
 * @returns {Object} Web check-in context value
*/
export const useWebCheckInContext = () => {
  const context = useContext(WebCheckInContext);
  
  if (!context) {
    throw new Error('useWebCheckInContext must be used within a WebCheckInProvider');
  }
  
  return context;
};

export default WebCheckInContext; 